module.exports = __webpack_public_path__ + "static/media/Lighting.40e3dcfb.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/pdf/Lighting.pdf
// module id = 383
// module chunks = 0